/**
 * @generated SignedSource<<a33bd637e82bd4b79900d194a997f7a6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type AffiliateName = "Adison" | "Buzzvil" | "Pincrux" | "Tnk";
export type CorpTypeEnum = "CORPS" | "INDIS";
export type ErrorType = "ERR_ADSLOT" | "ERR_CARD_BIRTH" | "ERR_CARD_EXPIRED" | "ERR_CARD_NUMBER" | "ERR_CARD_PASSWORD" | "ERR_CARD_PASSWORD_FIVE_TIMES" | "ERR_CREATE_SURVEY_ANSWER" | "ERR_DUPLICATE_APPLY" | "ERR_ETC" | "ERR_EXIST_FINISH_REFUND" | "ERR_EXIST_SEARCH_HISTORY" | "ERR_EXPIRE_URL" | "ERR_HECTO_ETC" | "ERR_HOMETAX_BLOCK_ID" | "ERR_HOMETAX_CALCULATE" | "ERR_HOMETAX_COLLECT" | "ERR_HOMETAX_ETC" | "ERR_HOMETAX_EXPIRE_CERT" | "ERR_HOMETAX_IMPOSSIBLE" | "ERR_HOMETAX_INPUT" | "ERR_HOMETAX_NO_BMAN" | "ERR_HOMETAX_NO_CONTINUE_BMAN" | "ERR_HOMETAX_NO_CORPS_ID" | "ERR_HOMETAX_NO_INCOME_TAX" | "ERR_HOMETAX_NO_JUMIN_ID" | "ERR_HOMETAX_NO_REGIST_CERT" | "ERR_HOMETAX_NO_USER" | "ERR_HOMETAX_OVERLOAD" | "ERR_HOMETAX_PASSWORD" | "ERR_HOMETAX_PASSWORD_CHANGE_REQUEST" | "ERR_HOMETAX_REG_NO" | "ERR_HOMETAX_SERVER_FIX" | "ERR_HOMETAX_SESSION" | "ERR_HOMETAX_SIMPLE_AUTH" | "ERR_HOMETAX_TIMEOUT" | "ERR_LEAVE_REASON" | "ERR_LEAVE_REASON_LOG" | "ERR_NON_PRODUCT_PROMOTION" | "ERR_NOT_EXIST_HISTORY" | "ERR_NOT_EXIST_YEAR_END_TAX_SETTLEMENT" | "ERR_NO_EQUAL_TIN" | "ERR_PROMOTION" | "ERR_SSO" | "ERR_SURVEY" | "ERR_SURVEY_ANSWER" | "ERR_SURVEY_COMPLETED" | "ERR_SURVEY_EXPIRED" | "ERR_UPDATE_SURVEY_ANSWER" | "ERR_USER" | "ERR_USER_ACTION_LOG" | "ERR_USER_PHONE";
export type OptionalTerms = {
  marketingAgree: boolean;
  thirdAgree: boolean;
};
export type PromotionData = {
  inviteCode: string;
  promotionCode: string;
};
export type AffiliateData = {
  appKey?: string | null | undefined;
  name: AffiliateName;
  trackingId: string;
};
export type searchRefundV2Mutation$variables = {
  affiliateData?: AffiliateData | null | undefined;
  clientId?: string | null | undefined;
  corpType: CorpTypeEnum;
  metaProperties?: string | null | undefined;
  optionalTerms?: OptionalTerms | null | undefined;
  promotionData?: PromotionData | null | undefined;
  reSearchRequestId?: number | null | undefined;
  refundToken: string;
  regNo?: string | null | undefined;
  tritxReSearchRequestId?: number | null | undefined;
  utmCampaign?: string | null | undefined;
  utmContent?: string | null | undefined;
  utmMedium?: string | null | undefined;
  utmSource?: string | null | undefined;
  utmTerm?: string | null | undefined;
};
export type searchRefundV2Mutation$data = {
  readonly searchRefundV2: {
    readonly errors: {
      readonly code: ErrorType;
    } | null | undefined;
    readonly result: boolean;
  };
};
export type searchRefundV2Mutation = {
  response: searchRefundV2Mutation$data;
  variables: searchRefundV2Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "affiliateData"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "clientId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "corpType"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "metaProperties"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "optionalTerms"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "promotionData"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "reSearchRequestId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "refundToken"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "regNo"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "tritxReSearchRequestId"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmCampaign"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmContent"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmMedium"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmSource"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "utmTerm"
},
v15 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "affiliateData",
        "variableName": "affiliateData"
      },
      {
        "kind": "Variable",
        "name": "clientId",
        "variableName": "clientId"
      },
      {
        "kind": "Variable",
        "name": "corpType",
        "variableName": "corpType"
      },
      {
        "kind": "Variable",
        "name": "metaProperties",
        "variableName": "metaProperties"
      },
      {
        "kind": "Variable",
        "name": "optionalTerms",
        "variableName": "optionalTerms"
      },
      {
        "kind": "Variable",
        "name": "promotionData",
        "variableName": "promotionData"
      },
      {
        "kind": "Variable",
        "name": "reSearchRequestId",
        "variableName": "reSearchRequestId"
      },
      {
        "kind": "Variable",
        "name": "refundToken",
        "variableName": "refundToken"
      },
      {
        "kind": "Variable",
        "name": "regNo",
        "variableName": "regNo"
      },
      {
        "fields": [
          {
            "kind": "Variable",
            "name": "campaign",
            "variableName": "utmCampaign"
          },
          {
            "kind": "Variable",
            "name": "content",
            "variableName": "utmContent"
          },
          {
            "kind": "Variable",
            "name": "medium",
            "variableName": "utmMedium"
          },
          {
            "kind": "Variable",
            "name": "source",
            "variableName": "utmSource"
          },
          {
            "kind": "Variable",
            "name": "term",
            "variableName": "utmTerm"
          }
        ],
        "kind": "ObjectValue",
        "name": "searchUtm"
      },
      {
        "kind": "Variable",
        "name": "tritxReSearchRequestId",
        "variableName": "tritxReSearchRequestId"
      }
    ],
    "concreteType": "SearchRefundV2Output",
    "kind": "LinkedField",
    "name": "searchRefundV2",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "result",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "Errors",
        "kind": "LinkedField",
        "name": "errors",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "searchRefundV2Mutation",
    "selections": (v15/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v1/*: any*/),
      (v6/*: any*/),
      (v9/*: any*/),
      (v4/*: any*/),
      (v3/*: any*/),
      (v13/*: any*/),
      (v12/*: any*/),
      (v10/*: any*/),
      (v14/*: any*/),
      (v11/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "searchRefundV2Mutation",
    "selections": (v15/*: any*/)
  },
  "params": {
    "cacheID": "10aac4b7e4c6a78c3e2fb3628037205e",
    "id": null,
    "metadata": {},
    "name": "searchRefundV2Mutation",
    "operationKind": "mutation",
    "text": "mutation searchRefundV2Mutation(\n  $corpType: CorpTypeEnum!\n  $refundToken: String!\n  $regNo: String\n  $clientId: String\n  $reSearchRequestId: Float\n  $tritxReSearchRequestId: Float\n  $optionalTerms: OptionalTerms\n  $metaProperties: String\n  $utmSource: String\n  $utmMedium: String\n  $utmCampaign: String\n  $utmTerm: String\n  $utmContent: String\n  $promotionData: PromotionData\n  $affiliateData: AffiliateData\n) {\n  searchRefundV2(corpType: $corpType, refundToken: $refundToken, regNo: $regNo, clientId: $clientId, reSearchRequestId: $reSearchRequestId, tritxReSearchRequestId: $tritxReSearchRequestId, optionalTerms: $optionalTerms, metaProperties: $metaProperties, searchUtm: {source: $utmSource, medium: $utmMedium, campaign: $utmCampaign, term: $utmTerm, content: $utmContent}, promotionData: $promotionData, affiliateData: $affiliateData) {\n    result\n    errors {\n      code\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "5c96842fc3759ab66202a6256938a576";

export default node;
